<template>
  <!-- Banner Section -->
  <section class="banner-section banner-six">
    <div class="floating-bg">
      <img src="@/assets/img/car.png" alt="" />
    </div>
    <div class="floating-watermark">
      <img src="@/assets/img/bg/banner-six-bg-1.png" alt="" />
      <img src="@/assets/img/bg/banner-six-bg-2.png" alt="" />
    </div>
    <div class="container">
      <div class="home-banner">
        <div class="row aos" data-aos="fade-up">
          <div class="col-lg-6">
            <div class="banner-contents">
              <h1
                class="aos"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Find / Sell a Car with your Favourite Listee.
              </h1>
              <p class="aos" data-aos="fade-up" data-aos-delay="200">
                Book better cars from local hosts Across the globe
              </p>
              <router-link to="categories">
                <span><i class="fa-solid fa-car"></i></span>List your car
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Banner Section -->
</template>